import { z } from "zod";
export const DocumentTypeSchema = z.enum([
  "SOW",
  "MSA",
  "ORDER_FORM",
  "INVOICE",
  "RECEIPT",
  "BILL",
  "VENDOR_SECURITY_QUESTIONNAIRE",
  "DATA_VENDOR_QUESTIONNAIRE",
  "SOC_2_TYPE_I_REPORT",
  "SOC_2_TYPE_II_REPORT",
  "OTHER",
  "UNKNOWN",
  "W_9",
  "DPA",
  "AMENDMENT",
  "NDA",
  "CERTIFICATE_OF_INSURANCE",
  "INFORMATION_SECURITY_POLICY",
  "BUSINESS_CONTINUITY_AND_DISASTER_RECOVERY",
  "ISO_27001",
  "COMPLIANCE_POLICY",
  "FINANCIALS",
  "BUSINESS_VERIFICATION",
  "PENETRATION_TEST",
  "THIRD_PARTY_RISK_MANAGEMENT_POLICY",
  "SERVICING_POLICY",
]);
